export default {
  name: 'marking--goodUpload',
  apiService: 'shoes',
  apiPath: '/admin/goods/func/upload',
  urlParamName: 'marking--goodUpload',
};